import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import * as XLSX from 'xlsx';
import { UtilsProvider } from '../../providers/utils/utils';
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos';
import { clientes } from '../../models/clientes';
import { ClientesProvider } from '../../providers/clientes/clientes';
import { Storage } from '@ionic/storage'
import { ProductosProvider } from '../../providers/productos/productos';
import { PushProvider } from '../../providers/push/push';
/**
 * Generated class for the SubirRegistrosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-subir-registros',
  templateUrl: 'subir-registros.html',
})
export class SubirRegistrosPage implements OnInit {
  selectedTable: string = 'productos';
  excelData: any[] = [];
  sqlData: any[] = [];
  comparisonData: any[] = [];

  headers: string[] = [];
  excelCount: number = 0;
  dbCount: number = 0;
  matchCount: number = 0;
  nombreTabla: string = "";
  compania:string = "";
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public utils: UtilsProvider,
    public servicio: ProductosPorGruposProvider,
    public providerClientes: ClientesProvider,
    public providerProductos: ProductosProvider,
    public storage: Storage,
    public push:PushProvider,) {
  }

  ngOnInit() {
    this.sqlData = []
    // this.sqlData = [
    //   {"nombreProducto":	"AGUACATE",
    //     "valorVenta":	2000.00,
    //     "existenciasActuales":	-1.0000,
    //     "tipoImpuesto": "I",
    //     "valorImpuesto":0.000000000,
    //     "codigoBarra":"2000",
    //     "tipoDeProducto":"P",
    //     "imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png",
    //     "costo":0.00
    //   },
    //   {"nombreProducto":	"DOMICILIOS",
    //     "valorVenta":	1.00,
    //     "existenciasActuales":	-1.0000,
    //     "tipoImpuesto": "I",
    //     "valorImpuesto":0.000000000,
    //     "codigoBarra":"5555",
    //     "tipoDeProducto":"P",
    //     "imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png",
    //     "costo":0.00
    //   },
    //   {"nombreProducto":	"RITZ",
    //     "valorVenta":	1400.00,
    //     "existenciasActuales":	-26.0000,
    //     "tipoImpuesto": "V",
    //     "valorImpuesto":0.000000000,
    //     "codigoBarra":"7622201389895",
    //     "tipoDeProducto":"P",
    //     "imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png",
    //     "costo":0.00
    //   },
    //   {"nombreProducto":	"MEZCLADORES",
    //     "valorVenta":	2500.00,
    //     "existenciasActuales":-1.0000,
    //     "tipoImpuesto": "I",
    //     "valorImpuesto":0.000000000,
    //     "codigoBarra":"7702523213334",
    //     "tipoDeProducto":"P",
    //     "imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png",
    //     "costo":0.00
    //   },
    //   {"nombreProducto":	"AGUA BRISA LITRO",
    //     "valorVenta":	2500.00,
    //     "existenciasActuales":-4.0000,
    //     "tipoImpuesto": "I",
    //     "valorImpuesto":0.000000000,
    //     "codigoBarra":"7702535013830",
    //     "tipoDeProducto":"P",
    //     "imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png",
    //     "costo":0.00
    //   },
    //   {"nombreProducto":	"VARIOS",
    //     "valorVenta":576000.00,
    //     "existenciasActuales":-2.0000,
    //     "tipoImpuesto": "V",
    //     "valorImpuesto":0.000000000,
    //     "codigoBarra":"999",
    //     "tipoDeProducto":"P",
    //     "imagen":"https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png",
    //     "costo":0.00
    //   }
    // ];
    this.dbCount = this.sqlData.length
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SubirRegistrosPage');
  }
  toggleEdit(row: any) {
    row.editing = !row.editing;
    row['actualizado'] = true
  }

  onFileSelectedUsuarioPorEntidad(event: any) {

  }

  onTableChange(event: any) {
    if(event === 'productos' && this.comparisonData.length>0 && this.sqlData.length>0) {
      this.fetchSQLData();
    }

  }

  fetchSQLData() {

    this.initializeComparisonData(this.sqlData);
  }

  // initializeComparisonData(data: any[]) {
  //   this.comparisonData = data.map(row => {
  //     return { ...row, editing: false };
  //   });
  //   console.log('Initial comparisonData:', this.comparisonData);
  //   this.calculateCounts();
  // }
//   initializeComparisonData(data: any[]) {
//   this.comparisonData = data.map(row => {
//     return { cells: row.cells || [], editing: false }; // Ajusta según la estructura real de tus datos
//   });
//   console.log('Initial comparisonData:', this.comparisonData);
//   this.calculateCounts();
// }

initializeComparisonData(data: any[]) {
  // Asegúrate de que data sea un array de arrays o ajusta según tu estructura
  this.comparisonData = data.map(row => {
    return Array.isArray(row) ? row : []; // Ajusta según la estructura real de tus datos
  });
  console.log('Initial comparisonData:', this.comparisonData);
  this.calculateCounts();
}

  calculateCounts() {
    // Aquí deberás reemplazar la lógica con la que comparas los datos del Excel y la base de datos
    this.excelCount = this.comparisonData.length;
    this.dbCount = 0; // Este valor debe ser el conteo real de la base de datos
    this.matchCount = this.comparisonData.filter(row => row.match).length; // Ajusta según tu lógica de coincidencia
  }

  // onFileSelected(event: any) {
  //   const file: File = event.target.files[0];
  //   const fileReader: FileReader = new FileReader();

  //   fileReader.onload = (e: any) => {
  //     const arrayBuffer: any = e.target.result;
  //     const workbook: XLSX.WorkBook = XLSX.read(arrayBuffer, { type: 'array' });

  //     // Leer la primera hoja del libro de Excel
  //     const worksheet: XLSX.WorkSheet = workbook.Sheets[workbook.SheetNames[0]];

  //     // Obtener los registros como objeto JSON
  //     const data: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  //     // this.guardar(data) para guardar clientes
  //   };

  //   fileReader.readAsArrayBuffer(file);
  // }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const fileReader: FileReader = new FileReader();

    fileReader.onload = (e: any) => {
      const arrayBuffer: any = e.target.result;
      const workbook: XLSX.WorkBook = XLSX.read(arrayBuffer, { type: 'array' });
      const worksheet: XLSX.WorkSheet = workbook.Sheets[workbook.SheetNames[0]];
      this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Aquí llamamos la función de comparación
      this.compareData();
    };

    fileReader.readAsArrayBuffer(file);
  }

  compareData() {
    // Aquí implementa la lógica para comparar this.excelData con this.sqlData.
    // Luego, llena this.comparisonData con los resultados de la comparación.
    this.comparisonData = this.excelData.map(excelRow => {
      const sqlRow = this.sqlData.find(sqlRow => sqlRow.identificacion === excelRow[0]);
      return sqlRow ? this.mergeData(sqlRow, excelRow) : excelRow;
    });
    this.headers = Object.keys(this.comparisonData[0]);
    this.excelCount = this.comparisonData.length;
  }

  mergeData(sqlRow: any, excelRow: any) {
    return {
      ...sqlRow,
      ...excelRow,
    };
  }



  editRecord(row: any) {
    // Aquí puedes implementar la lógica para permitir la edición de registros
  }

  migrarDatos() {
    if (this.selectedTable === 'clientes') {
      this.guardarClientes(this.excelData);
    } else if (this.selectedTable === 'productos') {
      this.guardarProductos(this.excelData);
    } else if (this.selectedTable === 'productosElaborados') {
      this.guardarProductosElaborados(this.excelData);
    }
  }

  // onFileSelected(event: any) {
  //   const file: File = event.target.files[0];
  //   const fileReader: FileReader = new FileReader();

  //   fileReader.onload = (e: any) => {
  //     const arrayBuffer: any = e.target.result;
  //     const workbook: XLSX.WorkBook = XLSX.read(arrayBuffer, { type: 'array' });
  //     const worksheet: XLSX.WorkSheet = workbook.Sheets[workbook.SheetNames[0]];
  //     this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  //   };

  //   fileReader.readAsArrayBuffer(file);
  // }

  guardarClientes(data: any) {
    this.storage.get('companiasId').then((val) => {
      const listaJson = data.map((items: any) => {
        return {
          tipoIdentificacion: 'C',
          identificacion: items[0],
          digito: '0',
          numeroTelefono: items[1],
          primerNombre: items[2],
          nombreCompleto: items[2],
          direccion: items[3],
          companiasId: val,
          entidadesId: items[4],
          nombreTabla: 'clientes',
          name: 'dataDynamicCrud',
          queHago: 'I',
          estado: 'A',
        };
      });

      this.subirDatos(listaJson);
    });
  }

  guardarInfoDeExcel() {
      const datosSinCabeceras = this.comparisonData.slice(1);
      const listaJson = datosSinCabeceras.map((items: any) => {
        return {
          nombreProducto:items[0],
          valorVenta:items[1],
          existenciasActuales:items[2],
          tipoImpuesto:items[3],
          valorImpuesto:items[4],
          codigoBarra:items[5],
          nombreGrupo:items[6],
          tipoDeProducto:items[7],
          imagen:items[8],
          costo:items[9],
          actualizado: !items[10]
        };
      });
      this.subirDatosDeExcel(listaJson);
  }

  guardarProductos(data: any) {
    this.storage.get('companiasId').then((val) => {
      const listaJson = data.map((items: any) => {
        return {
          codigoProducto: items[0],
          nombreProducto: items[1],
          valorVenta: items[2],
          existenciasMinimas: items[3],
          existenciasActuales: items[4],
          companiasId: val,
          nombreTabla: 'productos',
          name: 'dataDynamicCrud',
          queHago: 'I',
        };
      });
      this.subirDatos(listaJson);
    });
  }

  guardarProductosElaborados(data: any) {
    this.storage.get('companiasId').then((val) => {
      const listaJson = data.map((items: any) => {
        return {
          codigoProductoElaborado: items[0],
          nombreProductoElaborado: items[1],
          valorVenta: items[2],
          companiasId: val,
          nombreTabla: 'productosElaborados',
          name: 'dataDynamicCrud',
          queHago: 'I',
        };
      });

      this.subirDatos(listaJson);
    });
  }

  subirDatosDeExcel(listaJson: any[]) {
    listaJson = listaJson[0]
    const batchSize = 1; // Tamaño del lote
    const totalBatches = Math.ceil(listaJson.length / batchSize);
    let currentBatch = 0;

    // Registra los índices de registros que necesitan ser reintentados
    let failedRecords = [];

    // Función para enviar el siguiente lote
    const sendNextBatch = () => {
      if (currentBatch >= totalBatches) {
        if (failedRecords.length > 0) {
          // Si hay registros fallidos, reintenta después de un breve retraso
          console.log('Reintentando registros fallidos...');
          setTimeout(() => {
            retryFailedRecords();
          }, 5000); // Retraso de 5 segundos antes de reintentar
        } else {
          this.utils.mensajeMuestro('Producto', 'Actualizados Exitosamente!', 'success');
        }
        return; // Todos los lotes han sido enviados
      }

      // Obtener el lote actual
      const start = currentBatch * batchSize;
      const end = Math.min(start + batchSize, listaJson.length);
      const batch = listaJson.slice(start, end);

      // Enviar el lote al servidor
      this.providerProductos.migrarProductosBase(batch, this.compania).subscribe(
        (res) => {
          try {
            const response = res; // Usa directamente `res` si es un objeto de respuesta
            const responseBody = response['_body'] ? JSON.parse(response['_body']) : null; // Ajusta según tu respuesta
            const responseNew = responseBody ? responseBody.data[0] : null;

            if (responseNew) {
              console.log(`Batch ${currentBatch + 1}/${totalBatches} - Respuesta del servidor:`, responseNew);
              this.descargarArchivoExcel(responseNew, `migracion_${currentBatch + 1}`);
            }

            currentBatch++; // Avanzar al siguiente lote
            sendNextBatch(); // Enviar el siguiente lote
          } catch (error) {
            console.error('Error procesando la respuesta:', error);
            failedRecords.push(batch[0]); // Añadir registro fallido a la lista
            currentBatch++; // Avanzar al siguiente lote
            sendNextBatch(); // Enviar el siguiente lote
          }
        },
        (err) => {
          console.error(`Batch ${currentBatch + 1}/${totalBatches} - Error:`, err);
          failedRecords.push(batch[0]); // Añadir registro fallido a la lista
          currentBatch++; // Avanzar al siguiente lote
          sendNextBatch(); // Enviar el siguiente lote
        }
      );
    };

    // Función para reintentar el envío de registros fallidos
    const retryFailedRecords = () => {
      if (failedRecords.length > 0) {
        console.log(`Reintentando ${failedRecords.length} registros...`);
        const retryBatchSize = 1; // Tamaño del lote para reintentos
        const totalRetryBatches = Math.ceil(failedRecords.length / retryBatchSize);
        let retryCurrentBatch = 0;

        const sendRetryBatch = () => {
          if (retryCurrentBatch >= totalRetryBatches) {
            this.utils.mensajeMuestro('Producto', 'Actualizados Exitosamente!', 'success');
            return; // Todos los registros fallidos han sido reintentados
          }

          const start = retryCurrentBatch * retryBatchSize;
          const end = Math.min(start + retryBatchSize, failedRecords.length);
          const retryBatch = failedRecords.slice(start, end);

          this.providerProductos.migrarProductosBase(retryBatch, this.compania).subscribe(
            (res) => {
              try {
                const response = res; // Usa directamente `res` si es un objeto de respuesta
                const responseBody = response['_body'] ? JSON.parse(response['_body']) : null; // Ajusta según tu respuesta
                const responseNew = responseBody ? responseBody.data[0] : null;

                if (responseNew) {
                  console.log(`Retry Batch ${retryCurrentBatch + 1}/${totalRetryBatches} - Respuesta del servidor:`, responseNew);
                  this.descargarArchivoExcel(responseNew, `migracion_retry_${retryCurrentBatch + 1}`);
                }

                retryCurrentBatch++; // Avanzar al siguiente lote
                sendRetryBatch(); // Enviar el siguiente lote de reintentos
              } catch (error) {
                console.error('Error procesando la respuesta de reintento:', error);
                retryCurrentBatch++; // Avanzar al siguiente lote en caso de error
                sendRetryBatch(); // Enviar el siguiente lote de reintentos
              }
            },
            (err) => {
              console.error(`Retry Batch ${retryCurrentBatch + 1}/${totalRetryBatches} - Error:`, err);
              retryCurrentBatch++; // Avanzar al siguiente lote en caso de error
              sendRetryBatch(); // Enviar el siguiente lote de reintentos
            }
          );
        };

        sendRetryBatch(); // Iniciar el proceso de reintento
      }
    };

    sendNextBatch(); // Iniciar el proceso de envío
  }

  // subirDatosDeExcel(listaJson: any[]) {
  //   const batchSize = 1; // Tamaño del lote
  //   const totalBatches = Math.ceil(listaJson.length / batchSize);
  //   let currentBatch = 0;

  //   // Función para enviar el siguiente lote
  //   const sendNextBatch = () => {
  //     if (currentBatch >= totalBatches) {
  //       this.utils.mensajeMuestro('Producto', 'Actualizados Exitosamente!', 'success');
  //       return; // Todos los lotes han sido enviados
  //     }

  //     // Obtener el lote actual
  //     const start = currentBatch * batchSize;
  //     const end = Math.min(start + batchSize, listaJson.length);
  //     const batch = listaJson.slice(start, end);

  //     // Enviar el lote al servidor
  //     this.providerProductos.migrarProductosBase(batch, this.compania).subscribe(
  //       (res) => {
  //         try {
  //           // Asegúrate de que la respuesta se maneje correctamente
  //           const response = res; // Usa directamente `res` si es un objeto de respuesta
  //           const result = response['_body'] ? JSON.parse(response['_body']) : []; // Ajusta según tu respuesta
  //           const responseNew = result.data[0]
  //           console.log(`Batch ${currentBatch + 1}/${totalBatches} - Respuesta del servidor:`, responseNew);

  //           if (responseNew) {
  //             this.descargarArchivoExcel(responseNew, `migracion_${currentBatch + 1}`);
  //           }

  //           currentBatch++; // Avanzar al siguiente lote
  //           sendNextBatch(); // Enviar el siguiente lote
  //         } catch (error) {
  //           console.error('Error procesando la respuesta:');
  //           currentBatch++; // Avanzar al siguiente lote en caso de error
  //           sendNextBatch(); // Enviar el siguiente lote
  //         }
  //       },
  //       (err) => {
  //         console.error(`Batch ${currentBatch + 1}/${totalBatches} - Error:`);
  //         // Manejo de errores: podrías reintentar o registrar el error según sea necesario
  //         currentBatch++; // Avanzar al siguiente lote en caso de error
  //         sendNextBatch(); // Enviar el siguiente lote
  //       }
  //     );
  //   };


  //   sendNextBatch(); // Iniciar el proceso de envío
  // }


  subirDatos(listaJson: any[]) {
    let listaJsonResponse = listaJson.filter((item) => item !== undefined);
    for (let i = 0; i < listaJsonResponse.length; i++) {
      this.providerProductos.guardarProducto(listaJsonResponse[i]).subscribe(
        (res) => {
          if (i + 1 === listaJsonResponse.length) {
            this.utils.mensajeMuestro(
              'Producto',
              'Actualizado Exitosamente!',
              'success'
            );
          }
        },
        (err) => {
          if (i + 1 === listaJsonResponse.length) {
            this.utils.mensajeMuestro(
              'Producto',
              'No se pudo actualizar el producto, intente luego',
              'warning'
            );
          }
        }
      );
    }
  }



  guardarproductos(data:any) {
    this.storage.get('companiasId').then((val) => {
      let companiasId = val

      let nombretabla = "productos";
      let datosProducto: any = {
          codigoProducto: 'P',
          nombreProducto: "this.nombreProducto",
          valorVenta: "this.valorVenta",
          existenciasMinimas:0,
          existenciasActuales: 0,
          visualizaEnCaja: true,
          controlaEnInventario: true,
          tipoImpuesto: 'I',
          valorImpuesto: 0,
          centroDeCostosId: 1,
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          codigoBarra:'',
          companiasId:val,
          costo:0,
          queHago: "I",
          nombreTabla: "productos",
          name: "dataDynamicCrud",
          unidad: 'UND'
        }

        if("E" === "E") {
          nombretabla = "productosElaborados";
          datosProducto = {
            companiasId: val,
            queHago: "I",
            nombreTabla: "productosElaborados",
            name: "dataDynamicCrud",
            productosElaboradosId:  "0",
            codigoProductoElaborado: "this.codigoProducto",
            nombreProductoElaborado: "this.nombreProducto",
            imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
            valorVenta: "this.valorVenta",
            tipoImpuesto: 'I',
            valorImpuesto: 8,
            imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
            estado: 0,
            prioridad: 0,
            codigoBarra:'',
            unidad: 'UND'
          }
      }

        let listaJson: any = data.map((items: any, index: number) => {
          return {
              tipoIdentificacion : 'C',
              identificacion : items[0],
              digito : '0',
              fechaExpedicion : '',
              primerApellido : '',
              numeroTelefono : items[1],
              segundoApellido : '',
              primerNombre : items[2],
              segundoNombre : '',
              nombreCompleto : items[2],
              fechaIngreso : '',
              estado : 'A',
              direccion : items[3],
              queHago: "I",
              companiasId: companiasId,
              entidadesId: items[4],
              nombreTabla: "clientes",
              name: "dataDynamicCrud"}
        })
        let listaJsonResponse = listaJson.filter((item)=> item !== undefined)
        for(let i=0;i<listaJsonResponse.length;i++){


        this.providerProductos.guardarProducto(listaJsonResponse[i])
        .subscribe(
          res => {
            if(i + 1 === listaJsonResponse.length) {
              this.utils.mensajeMuestro('Producto','Actualizado Exitosamente!','success')
            }
          },
          err => {
            if(i + 1 === listaJsonResponse.length) {
              this.utils.mensajeMuestro('Producto','No se pudo actualizar el producto, intente luego','warning')
            }
          }
        )
        }
  }
  )}

  guardarclientes(data:any) {
    this.storage.get('companiasId').then((val) => {
      let companiasId = val
        let listaClientesJson: any = data.map((items: any, index: number) => {
          return {
              tipoIdentificacion : 'C',
              identificacion : items[0],
              digito : '0',
              fechaExpedicion : '',
              primerApellido : '',
              numeroTelefono : items[1],
              segundoApellido : '',
              primerNombre : items[2],
              segundoNombre : '',
              nombreCompleto : items[2],
              fechaIngreso : '',
              estado : 'A',
              direccion : items[3],
              queHago: "I",
              companiasId: companiasId,
              entidadesId: items[4],
              nombreTabla: "clientes",
              name: "dataDynamicCrud"}
        })
        let listaClientesJsonResponse = listaClientesJson.filter((item)=> item !== undefined)
        for(let i=0;i<listaClientesJsonResponse.length;i++){


        this.providerClientes.guardar(listaClientesJsonResponse[i])
        .subscribe(
          res => {
            if(i + 1 === listaClientesJsonResponse.length) {
              this.utils.mensajeMuestro('Clientes','Actualizado Exitosamente!','success')
            }
          },
          err => {
            if(i + 1 === listaClientesJsonResponse.length) {
              this.utils.mensajeMuestro('Clientes','No se pudo actualizar el cliente, intente luego','warning')
            }
          }
        )
        }
  }
  )}

  descargar() {
    if(this.comparisonData.length>0) {
      this.descargarArchivoExcel(this.comparisonData, 'datos editados de excel')
    }
  }

  descargarArchivoExcel(data:any,nombre:string) {
    this.utils.descargarArchivoExcel(data,nombre);
  }

  bajarDatosPorEmpresa(nombreTabla:string,companiasId:any) {
    this.push.cualquiercosa(`select * from ${nombreTabla} where companiasId=${companiasId}`).subscribe((data)=>{
      let valores = []
      valores =  JSON.parse(data['_body']).data[0]
      this.descargarArchivoExcel(valores, `${nombreTabla}-${companiasId}`)
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/subir-registros/subir-registros.ts